import { createAsyncThunk } from "@reduxjs/toolkit";
import { webhookLibraryNetworkService } from "./webhookLibraryNetworkService";

export class WebhookLibraryNetworkActions {
  //* CREATE MARKETING LIST  //
  static getWebhookList = createAsyncThunk(
    "broadcastSlice/getApiList",
    (data: any, { dispatch, rejectWithValue }) => {
      return webhookLibraryNetworkService.getWebhookList(data)
        .then(async (response: any) => {
          console.log("==> response",response)
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );
  
  static getContactProperties = createAsyncThunk(
    "broadcastSlice/getContactProperties",
    (data: any, { dispatch, rejectWithValue }) => {
      return webhookLibraryNetworkService.getContactProperties()
        .then(async (response: any) => {
          return response;
        })
        .catch((error: { response: unknown }) => {
          return rejectWithValue(error?.response);
        })
        .finally(() => {});
    }
  );
}
